import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import format from 'date-fns/format';
import { take, tap } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { CategoriesApiService, categoryRaw } from "../../api/categories-api.service";
import { JarvisApiService, personData } from "../../api/jarvis-api.service";
import { cliente, PcrcApiService } from "../../api/pcrc-api.service";
import { changesReport, posibleFilterFields, ReportsApiService } from "../../api/reports-api.service";
import { Article } from '../../article';
import { StateService } from "../../services/state.service";
import { RTEViewComponent } from "../rteview/rteview.component";
import { ExportExcelService } from 'src/app/api/export-excel.service';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2'
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

declare global {
  interface Window {
      htmldiff:any;
  }
}


@Component({
  selector: 'app-reporte-cambios',
  templateUrl: './reporte-cambios.component.html',
  styleUrls: ['./reporte-cambios.component.css']
})
export class ReporteCambiosComponent implements OnInit {
  @ViewChild(RTEViewComponent, { static: false })
  rteview: RTEViewComponent;
  filterCambio=""
  p=1
  public page:number= 1
  public initialDateDrop = false
  public finalDateDrop = false
  
  public categoryDrop = false
  public articlesDrop = false

  public isDirectorActive = false
  public isGerenteActive = false
  public isCoordinadorActive = false
  public isLiderActive = false
  public isPcrcActive = false
  public isCategoriaActive = false
  public isArticleActive = false  

  clientesList: cliente[]
  pcrcList: cliente['pcrcs'][0][]
  categoriesList: {
    state: "finish" | "loading";
    value?: categoryRaw[];
  }

  directores: personData[]
  gerentesList: personData[]
  coordisList: personData[]
  lideresList: personData[]

  selectedCliente: cliente
  selectedPcrc: cliente['pcrcs'][0]
  selectedCategory: categoryRaw
  selectedArticle: Article

  selectedDirector: personData
  selectedGerente: personData
  selectedCoordi: personData
  selectedLider: personData

  initialDate:Date
  finalDate:Date
  initialDateHumanRead = ''
  finalDateHumanRead = ''
  initialDateParam=''
  finalDateParam=''
  date=''

  data:any;
  data2:any[] =[]
  verificar:boolean;
  currentPage = 1;
  pageSize = 12;
  totalItems:number = 0;

  tableIsLoading = false;

  selectedData: changesReport['items'][0];
  previousState: changesReport['items'][0];

  textClient=""
  textPcrc=""
  cargando = false
  constructor(
    public state: StateService,
    public pcrcApi: PcrcApiService,
    public jarvisApi: JarvisApiService,
    public categoriesApi: CategoriesApiService,
    public reportsApi: ReportsApiService,
    public excelservice:ExportExcelService,
    public router:Router,
    @Inject(DOCUMENT) private document:Document,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.cargando= true
    this.pcrcApi.getUserPcrc(this.state.getValueOf('user').sub, 0, 1000).pipe(
      tap(pcrcs => {
        this.clientesList = [{ cliente:'Cualquiera', id_dp_clientes:0, pcrcs:[] }, ...pcrcs]
        this.cargando= false
      })
    ).subscribe()

  /*   this.jarvisApi.getClientDirectores('all').pipe(
      tap(directores => {
        this.directores = [{ cedula: '0', nombre: 'Cualquiera' }, ...directores]
      })
    ).subscribe() */
    this.verificar=false;

  }

  getClient(e){
   this.textClient=e
  }

  getPcrc(e){
    this.textPcrc=e
   }
 

  clienteSelected(selectedClient: cliente) {

    this.selectedCliente = selectedClient

    this.isPcrcActive = true

    this.pcrcList = [ { cod_pcrc:'0', id_dp_pcrc:0, pcrc:'Cualquiera' } , ...selectedClient.pcrcs ]

    this.categoriesList = null

    this.selectedCategory = null

    this.selectedPcrc = null

  }

  pcrcSelected(event: cliente['pcrcs'][0]) {

    this.selectedPcrc = event

    this.selectedCategory = null

    this.categoriesApi.getCategories(this.selectedPcrc.id_dp_pcrc.toString()).pipe(
      tap(categories => {
        if(categories.state == 'finish'){
          this.categoriesList = { state:'finish', value:[ {
            icon:'',
            id:'',
            name:'Cualquiera',
            parent_id:'',
            base_id:'',
            position:0
          }, ...categories.value] }

        } else {
          this.categoriesList = categories

        }

        this.isCategoriaActive = true;
      })
    ).subscribe()

  }

  categorySelected(event: categoryRaw) {

    this.selectedCategory = event

    this.isArticleActive = true

  }

  articleSelected(event: Article) {
    this.articlesDrop = false
    this.selectedArticle = event
  }

  onInitialDateChange(event: { value: Date }) {
    this.initialDate = event.value
    this.initialDate.setHours(0)
    this.initialDate.setMinutes(0)
    this.initialDateHumanRead = format(this.initialDate, "dd/MM/y")
    this.initialDateParam = format(this.initialDate, "y-MM-dd")
  }

  onFinalDateChange(event: { value: Date }) {
    this.finalDate = event.value
    this.finalDate.setHours(23)
    this.finalDate.setMinutes(59)
    this.finalDateHumanRead = format(this.finalDate, "dd/MM/y")
    this.finalDateParam = format(this.finalDate, "y-MM-dd")
    this.date=(this.finalDate.getFullYear()+"/"+(this.finalDate.getMonth()+1)+"/"+(this.finalDate.getDate()+1))
  }  

 /*  onDirectorSelected(directorSelected: personData) {

    console.log(directorSelected)

    this.selectedDirector = directorSelected;

    this.jarvisApi.getDirectorGerentes(directorSelected.cedula).pipe(
      tap(gerentes => {
        this.gerentesList = [{ cedula: '0', nombre: 'Cualquiera' }, ...gerentes]
        this.isGerenteActive = true;
      })
    ).subscribe()

  }

  onGerenteSelected(gerenteSelected: personData) {
    this.selectedGerente = gerenteSelected

    this.jarvisApi.getGerenteCoordis(gerenteSelected.cedula).pipe(
      tap(coordis => {
        this.coordisList = [{ cedula: '0', nombre: 'Cualquiera' }, ...coordis];
        this.isCoordinadorActive = true;
      })
    ).subscribe()
  }

  onCoordiSelected(coordiSelected: personData) {
    this.selectedCoordi = coordiSelected

    this.jarvisApi.getCoordiLideres(coordiSelected.cedula).pipe(
      tap(lideres => {
        this.isLiderActive = true
        this.lideresList = [{ cedula: '0', nombre: 'Cualquiera' }, ...lideres]
      })
    ).subscribe()
  }

  onLiderSelected(selectedLider: personData) {
    this.selectedLider = selectedLider
  } */

  search() {
   
    this.getFilters();
   
  }

  limpiar(){
    this.router.navigate(['/app/redirect/cambios'])
  }

  getverify(data){

    if((([].concat.apply({}, data).length)-1)===0){
      this.verificar=false;
   }else{
     this.verificar=true;
   }
  }

  getFilters() {

    if(this.initialDateParam=="" || this.finalDateParam==""){
      return Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: this.translate.instant('LLenar campos de fecha')
      })
    }



    if(!this.textClient){
      return Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: this.translate.instant('Selecciona el cliente')
      })
    }

    if(!this.textPcrc){
      return Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: this.translate.instant('Selecciona el pcrc')
      })
    }

    document.getElementById('table').classList.remove('hide')
    document.getElementById('table').classList.add('show')
    document.getElementById('cambio').classList.remove('hide')
    document.getElementById('cambio').classList.add('show')


    

     this.document.getElementById('arrow').classList.add('show')

    this.tableIsLoading=true

    let filter1: { filter: posibleFilterFields, value: string }

   /*  let filter2: { filter: posibleFilterFields, value: string } */

    if (!!this.selectedCliente && this.selectedCliente.cliente != 'Cualquiera') {
      filter1 = { value: this.selectedCliente.id_dp_clientes.toString(), filter: 'cliente' }
      if (!!this.selectedPcrc && this.selectedPcrc.pcrc != 'Cualquiera') {
        filter1 = { value: this.selectedPcrc.id_dp_pcrc.toString(), filter: 'pcrc' }
        let data=this.reportsApi.getCambios(this.selectedPcrc.id_dp_pcrc,this.initialDateParam,this.finalDateParam);
            data.subscribe(

               (data:any)=> {
               
                 this.data=data   
                 this.getverify(data)
                 this.tableIsLoading=false
               }
               
              ) 

              this.reportsApi.getCambioLimit(this.selectedPcrc.id_dp_pcrc,this.initialDateParam,this.finalDateParam, this.page).pipe(
                take(1),
                tap((res:any)=>{
                  this.data2 = res
                 
                })
              ).subscribe()

      }
    }

   /*  if (!!this.selectedDirector && this.selectedDirector.cedula != '0') {
      filter2 = { filter: 'director', value: this.selectedDirector.cedula }
      if (!!this.selectedGerente && this.selectedGerente.cedula != '0') {
        filter2 = { filter: 'gerente', value: this.selectedGerente.cedula }
        if (!!this.selectedCoordi && this.selectedCoordi.cedula != '0') {
          filter2 = { filter: 'coordinador', value: this.selectedCoordi.cedula }
          if (!!this.selectedLider && this.selectedLider.cedula != '0') {
            filter2 = { filter: 'lider', value: this.selectedLider.cedula }
          }
        }
      }
    }

    return [ filter1, filter2].filter(f => f) */
  }
/*
  pageSelected(event){
    this.currentPage = event
    this.search()
  }

  rowSelected(event:{data:changesReport['items'][0]}){
    this.selectedData = event.data
    this.previousState = undefined

    this.rteview.setContent('')

    if(this.selectedData.previoustate){
      this.reportsApi.getChange(this.selectedData.previoustate)
      .pipe(
        tap(result => this.previousState = result),
        tap(result => {
          if(result.articlecontent && this.selectedData.articlecontent){
            this.calculateDiff(JSON.parse(result.articlecontent), JSON.parse(this.selectedData.articlecontent))
          }
        })
      )
      .subscribe()

    }
  }

   calculateDiff(prev ,current){   

    let prevString = prev.ops.reduce((accumulator, currentValue)=>{
      return accumulator + ',\n' + JSON.stringify(currentValue)
    },'{"insert":"\\n"}')

    let currentString = current.ops.reduce((accumulator, currentValue)=>{
      return accumulator + ',\n' + JSON.stringify(currentValue)
    },'{"insert":"\\n"}')

    var diffObj = diff.diffLines(prevString, currentString)

    let diffArray:any[][] = diffObj.map(delta =>{
      let quillDelta:any
      if(delta.removed){
        let deltaCompleted = '['+this.quitarSaltoAlfinal(delta.value)+']'        
        quillDelta = JSON.parse( deltaCompleted )
        quillDelta = [...[{"insert":"\n\nContenido anterior"},{"attributes":{"blockquote":true},"insert":"\n"}],...quillDelta]
      } else if(delta.added) {
        let deltaCompleted = '['+this.quitarSaltoAlfinal(delta.value)+']'
        quillDelta = JSON.parse( deltaCompleted )        
        quillDelta = [...[{"insert":"\n\nContenido nuevo"},{"attributes":{"blockquote":true},"insert":"\n"}],...quillDelta]
        
      } else {
        let deltaCompleted = '['+this.quitarSaltoAlfinal(delta.value)+']'
        quillDelta = JSON.parse( deltaCompleted )        
        quillDelta = [...[{"insert":"\n\nSin cambio"},{"attributes":{"blockquote":true},"insert":"\n"}],...quillDelta]
      }

      return quillDelta

    })

    diffArray = diffArray.reduce((acumulator, current, index)=>{
      return [...acumulator,...current]
    },[])

    this.rteview.setContent(diffArray)

  }

  quitarSaltoAlfinal(texto:string){
    if( texto.substr(-2) == ',\n' ){
      return texto.slice(0,-2)
    }
    return texto
  } */

  preview(){
    if(this.page ==1){
      return
    }
    this.page --
    
    this.reportsApi.getCambioLimit(this.selectedPcrc.id_dp_pcrc,this.initialDateParam,this.finalDateParam, this.page).pipe(
      take(1),
      tap((res:any)=>{
        this.data2 = res
     
      })
    ).subscribe()
  }
  next(){
    this.page ++
    
    this.reportsApi.getCambioLimit(this.selectedPcrc.id_dp_pcrc,this.initialDateParam,this.finalDateParam, this.page).pipe(
      take(1),
      tap((res:any)=>{
        this.data2 = res
     
      })
    ).subscribe()
  
  }
  
  exportExcel(){


    const ws:XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.data)
    const wb:XLSX.WorkBook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb,ws,'sheet');
    XLSX.writeFile(wb, 'ControlCambio.xlsx')

  }


}
